// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3sE_o","errorLogs":"styles_errorLogs__EXo9t"};